import {useMemo} from 'react';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {
    isRbacAction,
    RbacAction
} from '../config/rbac/actions.ts';

// FNP-1934: the shared provider returns string[]. Narrowing it to RbacAction here
// makes allowedActions.includes() reject an action that is not in config/rbac/actions.ts.
export const useAllowedActions = () => {

    const {allowedActions, authorizing, status} = useVerifiedPermissions();

    const typed = useMemo<readonly RbacAction[]>(
        () => allowedActions.filter(isRbacAction),
        [allowedActions]
    );

    return {
        allowedActions: typed,
        authorizing,
        status,
    };

};
